

























import Vue from 'vue'
import { Page } from '@/interfaces/Page'
import { CustomPageMeta } from '@/interfaces/CustomPageMeta'
import { ShareMeta } from '@/interfaces/ShareMeta'
import SocialShareButtons from '@/components/SocialShareButtons.vue'
import share from '@/assets/share-meta.json'

export default Vue.extend({
  components: {
    SocialShareButtons,
  },
  computed: {
    page(): Page & CustomPageMeta {
      return this.$store.state.page.custom
    },
    shareMeta(): ShareMeta {
      return share
    },
    shareText(): string {
      const hasCustomShareText = Object.prototype.hasOwnProperty.call(this.shareMeta, this.page.id)
      return hasCustomShareText ? this.shareMeta[this.page.id] : this.shareMeta.default
    },
  },
  methods: {
    onPrint(): void {
      window.print()
    },
  },
})
